import { ASSIGNMENT_PROCESSING_STATUSES } from '../../../../constants/assignment-processing-statuses'
import { actions } from '../../../reducers/assignments.reducer'

export const reviveAssignmentQueryStarted = async ({ token }, { dispatch, queryFulfilled }) => {
    await queryFulfilled

    dispatch(actions.updateAssignmentProcessingStatus(token, ASSIGNMENT_PROCESSING_STATUSES.READY))
}

export const clearAssignmentFilesQueryStarted = async ({ token }, { dispatch, queryFulfilled }) => {
    await queryFulfilled

    dispatch(actions.updateAssignmentTotalFilesStatus(token, 0))
}
